import { render, staticRenderFns } from "./DepartmentNew.vue?vue&type=template&id=78b25c11&scoped=true&"
import script from "./DepartmentNew.vue?vue&type=script&lang=ts&"
export * from "./DepartmentNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b25c11",
  null
  
)

export default component.exports